import React, { Component } from 'react';
import './Configurator.css';
import Urls from '../urls/Urls';
import IconButton from './IconButton';
import HashSource from '../core/HashSource';
import ParameterErrors from '../errors/ParameterErrors';
const{throwNotProvided}=ParameterErrors;
export default class Configurator extends Component{
	constructor(props){
		super(props);
		const{hide, getInsertedMenuItemsHandler, configuration}=props;
		this._configuration = configuration;
		if(!getInsertedMenuItemsHandler)throwNotProvided('getInsertedMenuItemsHandler');
		this._callbackHide = hide;
		this.showConfiguratorForPlot = this.showConfiguratorForPlot.bind(this);
		this.closeCurrentConfigurator = this.closeCurrentConfigurator.bind(this);
		this._handleClickButtonBack = this._handleClickButtonBack.bind(this);
		this._iframeLoaded= this._iframeLoaded.bind(this);	
		this._nextIframeKey = this._nextIframeKey.bind(this);
		this._getInsertedMenuItemsHandler = getInsertedMenuItemsHandler;
		this.state = {iframes:null, visible:false};
		this._iframeCount =0;
	}
	componentDidMount(){
		
	}
	setVisible(value){
		this._insertedMenuItemsRemoveHandle?.dispose();
		this._insertedMenuItemsRemoveHandle = null;
		if(value){
			this._insertedMenuItemsRemoveHandle = this._getInsertedMenuItemsHandler().registerMenuItems([
					(<IconButton className="configurator-back-button" imgUrl ={Urls.assets+'icons/UI_Button_Exit.png'} onClick={this._handleClickButtonBack} key={HashSource.next()}></IconButton>)
				]
			);
		}
		this.setState({visible:value});
	}
	showConfiguratorForPlot(options){
		this.closeCurrentConfigurator();
		const {plot, roomName}=options
		const roomStr = roomName?`#${roomName}`:'';
		let url = Urls.getConfiguratorUrlForPlot(plot, this._configuration);
		if(roomStr&&url){
			url+=roomStr;
		}
		const iframe = (
			<div className="iframe-wrapper">
				<iframe src={url} className="iframe-configurator" key={this._nextIframeKey()} style={{height:'100%'}} onLoad={this._iframeLoaded}></iframe>
			</div>);
		this.setState({iframes:[iframe]});
	}
	_handleClickButtonBack(){
		this.closeCurrentConfigurator();
		this._callbackHide();
	}
	_iframeLoaded(e){
	}
	closeCurrentConfigurator(){
		this.setState({iframes:[]});
	}
	_nextIframeKey(){
		return `iframe_${(this._iframeCount++)}`;
	}
	render(){
		const className="configurator"+(this.state.visible?" visible":"");
		return (<div className={className}>{this.state.iframes}</div>);
	}
}
